import { render } from "./FormFileData.vue?vue&type=template&id=843883f4&scoped=true"
import script from "./FormFileData.vue?vue&type=script&lang=js"
export * from "./FormFileData.vue?vue&type=script&lang=js"

import "./FormFileData.vue?vue&type=style&index=0&id=843883f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-843883f4"

export default script